export function getContextMenuItems() {
  return ['copy', 'copyWithHeaders', 'export', 'autoSizeAll'];
}
